// extracted by mini-css-extract-plugin
export default {"utilityCompanies":"UtilityCompanies_utilityCompanies__V-H2p","img":"UtilityCompanies_img__+SnO9"};